"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./countries.cjs");exports.COUNTRIES=e.COUNTRIES;
//# sourceMappingURL=index.cjs.map
